import { mdiCircle } from '@mdi/js';
import Icon from 'components/Icon/Icon';
import React from 'react';

interface Props {
  type: MarkerIconType;
  settings?: MarkerIconSettings;
  selected?: boolean;
}

interface MarkerIconSettings {
  width?: number;
  height?: number;
  viewBox?: string;
}

export type MarkerIconType =
  | 'waiting'
  | 'waitingToConfirm'
  | 'planned'
  | 'open'
  | 'completed'
  | 'cancel'
  | 'run'
  | 'info'
  | 'multipoint'
  | 'address'
  | 'departure'
  | 'hasIntervention'
  | 'single';

const defaultSettings = {
  size: '44px',
  viewBox: '0 0 44 48'
};

const selectedSettings = {
  size: '56px',
  viewBox: '0 0 44 48'
};

const markerPath = 'M22,48c1.45,0,2.86-3.93,4.23-4.2a22,22,0,1,0-8.92-.09C18.82,44,20.39,48,22,48Z';

const MarkerIcon = (props: Props) => {
  const { type, selected } = props;

  const settings = {
    ...defaultSettings,
    ...props.settings
  };

  if (type === 'multipoint' && selected) {
    return (
      <div className="MarkerIcon_wrapper">
        <Icon
          path={markerPath}
          className="MarkerIcon"
          viewBox={selectedSettings.viewBox}
          size={selectedSettings.size}
          fill="#ff383f"
        />
        <Icon path={mdiCircle} fill="#fff" size="16px" className="MarkerDot" />
      </div>
    );
  }

  if (selected && type !== 'address') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon selected"
        viewBox={selectedSettings.viewBox}
        size={selectedSettings.size}
        fill="#ff383f"
      />
    );
  }

  if (type === 'waiting') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#efe071"
      />
    );
  }

  if (type === 'waitingToConfirm') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#ff6105"
      />
    );
  }

  if (type === 'planned' || type === 'open') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#c0cad0"
      />
    );
  }

  if (type === 'hasIntervention') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#8d9ba3"
      />
    );
  }

  if (type === 'completed') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#377d22"
      />
    );
  }

  if (type === 'cancel') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#969da1"
      />
    );
  }

  if (type === 'departure') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#9edfff"
      />
    );
  }

  if (type === 'run') {
    return (
      <Icon
        path={markerPath}
        className="MarkerIcon"
        viewBox={settings.viewBox}
        size={settings.size}
        fill="#6eb0d1"
      />
    );
  }

  if (type === 'multipoint' || (type === 'address' && selected) || type === 'single') {
    return (
      <div className="MarkerIcon_wrapper">
        <Icon
          path={markerPath}
          className="MarkerIcon"
          viewBox={settings.viewBox}
          size={settings.size}
          fill="#F29637"
        />
        <Icon path={mdiCircle} fill="#fff" size="16px" className="MarkerDot" />
      </div>
    );
  }

  if (type === 'address' && !selected) {
    return (
      <div className="MarkerIcon_wrapper">
        <Icon
          path={markerPath}
          className="MarkerIcon"
          viewBox={settings.viewBox}
          size={settings.size}
          fill="#969da1"
        />
        <Icon path={mdiCircle} fill="#fff" size="16px" className="MarkerDot" />
      </div>
    );
  }

  return (
    <Icon
      path={markerPath}
      className="MarkerIcon"
      viewBox={settings.viewBox}
      size={settings.size}
      fill="#fff"
    />
  );
};

export default MarkerIcon;
